module.exports = __webpack_public_path__ + "img/blog1.73eabe89.png";